import type { BookingSearch } from "@/lib/bookingSearch"
import { buildServicesCollection } from "@/lib/services/buildCollection"

export const buildBookingSearchCacheStore = (
  overrides?: Partial<BookingSearch.Cache.Store>
): BookingSearch.Cache.Store => {
  return buildServicesCollection(overrides)
}
